export const vibrationRegistry = {
    areas: [
        {
            id: 5,
            area_name: "Area 1",
            machines: [
                {
                    id: 5,
                    machine_name: "Machine 1",
                    motors: [
                        {
                            id: 1386,
                            motor_name: "Pump Bearing casing",
                            erc: "5",
                            capacity: "Class 3 (>75 kW/100 HP)",
                            shaft_parallel: "y",
                            shaft_perpendicular: "x",
                            shaft_vertical: "z",
                            limits: {
                                normal: 4.5,
                                marginal: 11.2,
                                temp_normal: 40,
                                temp_marginal: 60,
                            },
                        },
                        {
                            id: 1387,
                            motor_name: "Motor DE ",
                            erc: "6",
                            capacity: "Class 3 (>75 kW/100 HP)",
                            shaft_parallel: "x",
                            shaft_perpendicular: "y",
                            shaft_vertical: "z",
                            limits: {
                                normal: 4.5,
                                marginal: 11.2,
                                temp_normal: 40,
                                temp_marginal: 60,
                            },
                        },
                        {
                            id: 1388,
                            motor_name: "Motor NDE",
                            erc: "6",
                            capacity: "Class 3 (>75 kW/100 HP)",
                            shaft_parallel: "y",
                            shaft_perpendicular: "x",
                            shaft_vertical: "z",
                            limits: {
                                normal: 4.5,
                                marginal: 11.2,
                                temp_normal: 40,
                                temp_marginal: 60,
                            },
                        },
                    ],
                },
            ],
        },
    ],
};
